// // CambioService.actions.ts
import { queryClient } from '@/shared/query-client/query-client';
import { useMutation, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { UseMutationsParams, UseUpdateParams, } from "@/shared/interfaces";
import { urlBackend } from "@/shared/constants";
import { getUrlParamsFetch } from "@/shared/utils";
import { toApiError } from "@/shared/utils/general";
import { erpApi } from "@/shared/axios";
const { get, post, put, patch } = erpApi();


import { Cambio, GetCambiosParams, CambioPagingRes, CrearCambioRequest, CambioResponse, ActualizarCambioRequest, CambiarEstadoRequest } from '@/erp/controlcambios/cambio-service/types/cambio.types';

// // get
// const BASE_URL_CAMBIOS = `${urlBackend}api/v1/cambios/`;
export const useFetchCambios = (
  params?: GetCambiosParams,
  enabled = true
) => {
   return useQuery({
    queryKey: ['cambios',...Object.values(params ?? {})],
    queryFn: async () => {return getCambios(params);},
    enabled,
  });
}

//`${urlBackend}api/v1/nodo?${queryParams}`,
export const getCambios = async (params?: GetCambiosParams):Promise<CambioPagingRes> => {

  const stateParams = { ...params };
  const queryParams = getUrlParamsFetch(stateParams);


  return (await get<CambioPagingRes>(`${urlBackend}api/v1/cambios?${queryParams}`,true)) as unknown as CambioPagingRes;
};

// // mis cambios (solo los del usuario autenticado; el gateway inyecta X-User-Name)

export const useFetchMisCambios = (
  params?: GetCambiosParams,
  enabled = true
) => {
  return useQuery({
    queryKey: ['mis-cambios', ...Object.values(params ?? {})],
    queryFn: async () => getMisCambios(params),
    enabled,
  });
};

export const getMisCambios = async (params?: GetCambiosParams): Promise<CambioPagingRes> => {
  const queryParams = getUrlParamsFetch({ ...params });
  return (await get<CambioPagingRes>(
    `${urlBackend}api/v1/cambios/mis-cambios?${queryParams}`,
    true
  )) as unknown as CambioPagingRes;;
};

// // create

export const useFetchPostCambioService = ({
  returnUrl,
  navigate
}: UseMutationsParams = {}) => {
  return useMutation({
    mutationFn: (data: CrearCambioRequest) => {
      return postCambioService(data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cambios'] });
      queryClient.invalidateQueries({ queryKey: ['mis-cambios'] });
      navigate && returnUrl && navigate(returnUrl);
      toast.success("Se ha guardado correctamiente el control de cambios");
    },
    onError: ((error) => {
      const data = toApiError(error)
      toast.error(data.message)
    }),
  });
};

export const postCambioService = async (data: CrearCambioRequest) => {
  return await post<Cambio>(`${urlBackend}api/v1/cambios`, data, true);
};

// export const postCambioService = async (data: CambioServiceForm) => {
//   return await post<CambioService>(`${urlBackend}api/v1/cambio-service/`, data, true);
// };

// // filter by id

export const useFetchGetByIdCambioService = (id: string)  => {
  return useQuery({
    queryKey: ['cambio', id],
    queryFn: async () => {
      return getByIdCambioService(id);
    },
    refetchOnWindowFocus: false,
  });
};

export const getByIdCambioService = async (id: string) : Promise<CambioResponse> => {
  return( await get<CambioResponse>(`${urlBackend}api/v1/cambios/${id}`, true)) as unknown as CambioResponse;

};



export const useFetchAreasByCambioId = (cambioId: string) => {
  return useQuery({
    queryKey: ['cambio-areas', cambioId],
    queryFn: () => get<{ areaId: string }[]>(`${urlBackend}api/v1/cambios/${cambioId}/areas`, true),
    enabled: !!cambioId,
  });
};
// // update

export const useFetchPutCambioService = ({
  navigate,
  returnUrl
}: UseMutationsParams = {}) => {
  return useMutation({
    mutationFn: ({ id, data }: UseUpdateParams<ActualizarCambioRequest>) => {
      return putCambioService({ id, data });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['cambios'] });
      queryClient.invalidateQueries({ queryKey: ['mis-cambios'] }); 

      queryClient.invalidateQueries({ queryKey: ['cambio', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['cambio-edicion', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['cambio-historial', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['cambio-areas', variables.id] });
      navigate && returnUrl && navigate(returnUrl);
      toast.success("Cambio actualizado");
    },
    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    },
  });
};

export const putCambioService = async ({
  id,
  data
}: UseUpdateParams<ActualizarCambioRequest>) => {
  // /propio: el backend valida que solo el creador pueda actualizar
  return put<CambioResponse>(`${urlBackend}api/v1/cambios/${id}/propio`, data, true);
};

///PATCH
export const useFetchPatchCambioEstado = () => {
  return useMutation({
    mutationFn: ({ id, data }: UseUpdateParams<CambiarEstadoRequest>) => {
      return patchCambioEstado({ id, data });
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['cambios'] });
      queryClient.invalidateQueries({ queryKey: ['mis-cambios'] });

      queryClient.invalidateQueries({ queryKey: ['cambio', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['cambio-historial', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['aprobaciones-cambio', variables.id] });
      toast.success("Estado actualizado");
    },
    onError: (error) => {
      const data = toApiError(error);
      toast.error(data.message);
    },
  });
};

export const patchCambioEstado = async ({
  id,
  data
}: UseUpdateParams<CambiarEstadoRequest>) => {
  return put<Cambio>(`${urlBackend}api/v1/cambios/${id}/estado-interno`, data, true);
};


export const reprogramarCambio = async ({ id, data }: {
  id: string;
  data: { fechaProgramada: string; horaProgramada: string; duracion: number };
}) => patch<CambioResponse>(`${urlBackend}api/v1/cambios/${id}/reprogramar`, data, true);

export const useFetchReprogramarCambio = () => {
  return useMutation({
    mutationFn: reprogramarCambio,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['cambios'] });
      queryClient.invalidateQueries({ queryKey: ['mis-cambios'] });

      queryClient.invalidateQueries({ queryKey: ['cambio', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['cambio-historial', variables.id] });
      toast.success("Cambio reprogramado");
    },
    onError: (error) => toast.error(toApiError(error).message),
  });
};
//CANCELAR
export const cancelarCambio = async (id: string) =>
  patch<Cambio>(`${urlBackend}api/v1/cambios/${id}/cancelar`, undefined, true);

export const useFetchCancelarCambio = () => {
  return useMutation({
    mutationFn: cancelarCambio,
    onSuccess: (_data, id) => {
      queryClient.invalidateQueries({ queryKey: ['cambios'] });
      queryClient.invalidateQueries({ queryKey: ['mis-cambios'] });

       queryClient.invalidateQueries({ queryKey: ['cambio', id] });
      queryClient.invalidateQueries({ queryKey: ['cambio-historial', id] });
      queryClient.invalidateQueries({ queryKey: ['aprobaciones-cambio', id] });
      toast.success("Cambio cancelado");
    },
    onError: (error) => toast.error(toApiError(error).message),
  });
};



// HISTORIAL
export interface HistorialCambioItem {
  historialCambioId: string;
  accion: string;
  detalle: string;
  usuario: string;
  fecha: string;
}

export const getHistorialCambio = async (id: string): Promise<HistorialCambioItem[]> =>
  (await get<HistorialCambioItem[]>(`${urlBackend}api/v1/cambios/${id}/historial`, true)) as unknown as HistorialCambioItem[];

export const useFetchHistorialCambio = (id: string, enabled = true) =>
  useQuery({
    queryKey: ['cambio-historial', id],
    queryFn: () => getHistorialCambio(id),
    enabled: !!id && enabled,
  });
///HISTORIAL 2

export const getHistorialCambioFiltrado = async (id: string, accion: string): Promise<HistorialCambioItem[]> =>
  (await get<HistorialCambioItem[]>(`${urlBackend}api/v1/cambios/${id}/historial/filtrado?accion=${accion}`, true)) as unknown as HistorialCambioItem[];

export const useFetchHistorialCambioFiltrado = (id: string,accion:string, enabled = true) =>
  useQuery({
    queryKey: ['cambio-historial', id],
    queryFn: () => getHistorialCambioFiltrado(id, accion),
    enabled: !!id && enabled,
  });
  ///

  export const getCambioParaEdicion = async (id: string): Promise<CambioResponse> => {
  return (await get<CambioResponse>(
    `${urlBackend}api/v1/cambios/${id}/edicion`, true
  )) as unknown as CambioResponse;
};

export const useFetchGetCambioParaEdicion = (id: string) => {
  return useQuery({
    queryKey: ['cambio-edicion', id],
    queryFn: async () => getCambioParaEdicion(id),
    refetchOnWindowFocus: false,
  });
};